import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { IAppState } from '@app/store';
import { select, Store } from '@ngrx/store';
import * as fromUser from '@app/core/user/store/reducers';

export const SKIP_LINKS = [
  '#main-content',
  '#main-navigation',
  '#headerSearch',
  '#footer',
  '#user-access',
  '#user-login'
];

@Component({
  selector: 'vc-skip-links',
  templateUrl: './skip-links.component.html',
  styleUrls: ['./skip-links.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SkipLinksComponent implements OnInit {
  @Input()
  skipLinkPath: string;

  links = SKIP_LINKS;

  isLogged: boolean;

  constructor(private store: Store<IAppState>) {}

  ngOnInit(): void {
    this.store.pipe(select(fromUser.isAuthenticated)).subscribe(
      res => {
        this.isLogged = res;
      },
      err => {
        console.error(err);
      }
    );
  }
}
